import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import grupoDocumentoService from "../../../services/gestionDocumentos/grupoDocumentoService";
import { Icon, Spinner, SpinnerSize, TooltipHost } from "@fluentui/react";
import themeBase from "../../../utils/theme/themeBase";
import COLORES from "../../../utils/theme/colores";

export interface IButtonDownloadDocumentos {
  url: string;
  nombre?: string;
}

export const DownloadFiles = ({ url, nombre }: IButtonDownloadDocumentos) => {
  const [loadPdf, setLoadPdf] = useState<boolean>(false);
  const dataApiBlobs = (ruls: string, nombre: string) => {
    setLoadPdf(true);
    grupoDocumentoService
      .getBase64({ listUrlBase: [url] })
      .then((res) => {
        if (res.status == 200) {
          if (res.data && res.data.length > 0 && res.data[0] != "") {
            const regex = /\/([^;]*)/;
            const matches = res.data[0].match(regex);
            if (matches && matches.length > 1) {
              const extension = matches[1];

              const link = document.createElement("a");
              link.href = res.data[0];
              link.download = nombre + "." + extension;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              setLoadPdf(false);
            }
          }
        }
      })
      .catch(function (e) {
        if (e.response) {
        }
      });
  };
  return (
    <TooltipHost content="Descargar">
      {loadPdf ? (
        <Spinner size={SpinnerSize.xSmall} />
      ) : (
        <Icon
          iconName="Download"
          style={{ cursor: "pointer", color: COLORES.Bases.Negro }}
          className={themeBase.classNamesIcon.iconFont}
          onClick={() => {
            dataApiBlobs(url, nombre!);
          }}
        />
      )}
    </TooltipHost>
  );
};
